import React from 'react';
import WorkDetail from '../Audits/WorkDetail';

const ManageBooking = () => <WorkDetail kind="booking" idKey="booking_id" listPath="/bookings" listLabel="Bookings" />;

export default ManageBooking;
